import { MessageQuickReplies } from './MessageQuickReplies.jsx'

/**
 * Quick-reply / link-button message.
 *
 * Three button kinds, matching the legacy `Buttons` component:
 *   - `web_url` with a `script:...:script:id:<id>:id` payload runs the
 *     embedded script (used for "open lead form" CTAs in legacy
 *     setups). We keep that behavior because customer libraries depend
 *     on it; the script runs in the parent window's context, not the
 *     shadow root.
 *   - `web_url` without that pattern is a link with click logging.
 *   - Anything else is a postback the bot consumes via
 *     `ochatbot.callAPI(button.payload, button.title, true, ...)`.
 *
 * `lead-form-trigger-<id>` payloads short-circuit the postback and
 * open the matching admin lead form via `FormContext`.
 *
 * `order-status-open` opens the in-panel order status overlay and sends
 * `ometrics-button-click~order-status-open` for logging (chat stream skips
 * GenAI on the server). If order status is disabled in config, the overlay
 * explains how to enable it.
 *
 * Quick replies stay visible on every bot row after click so visitors
 * can scroll back and reuse intent or link buttons in the thread.
 */
export function ButtonsMessage({ message, ochatbot, conf }) {
  const buttons = Array.isArray(message.buttons) ? message.buttons : []
  const hasButtons = buttons.length > 0
  const hasText = Boolean(message.text && String(message.text).trim())

  if (!hasText && !hasButtons) return null

  return (
    <div className="ometrics-msg-buttons">
      {hasText && (
        <div
          className="ometrics-msg-text mb-2 [&_a]:underline [&_img]:max-h-[50vh] [&_img]:max-w-full [&_img]:object-contain"
          dangerouslySetInnerHTML={{ __html: message.text }}
        />
      )}
      {hasButtons ? (
        <MessageQuickReplies
          buttons={buttons}
          messageId={message.id}
          conf={conf}
          ochatbot={ochatbot}
        />
      ) : null}
    </div>
  )
}
